const { getTransactions, createTransaction, disableTransaction, enableTransaction, getReceipt } = require('@/controllers/transactions').ct_transactions;

const initialState = () => ({
    transactions: [],
    summary: {},
    pagination: {},
});

const state = initialState();

const mutations = {
    SET_TRANSACTIONS(state, { data, summary = {}, pagination = {} }) {
        state.transactions = data;
        state.summary = summary;
        state.pagination = pagination;
    },
    RESET_TRANSACTIONS_STATE(state) {
        Object.assign(state, initialState());
    },
};

const getters = {
    get_transactions(state) {
        return {
            data: state.transactions,
            summary: state.summary,
            pagination: state.pagination,
        };
    },
};

const actions = {
    // params.type é obrigatório: 'purchase' | 'sale'
    async load_transactions({ commit }, params) {
        if (!params?.type) {
            throw 'Informe o tipo do lançamento';
        }

        const response = await getTransactions(params);

        if (!response.status) {
            throw response.error;
        }

        commit('SET_TRANSACTIONS', response);
        return response;
    },

    async create_transaction(_, payload) {
        const response = await createTransaction(payload);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    async disable_transaction(_, id) {
        const response = await disableTransaction(id);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    async enable_transaction(_, id) {
        const response = await enableTransaction(id);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },

    // { transaction, contact_receipt, internal_report }
    async load_receipt(_, id) {
        const response = await getReceipt(id);

        if (!response.status) {
            throw response.error;
        }

        return response.data;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
